import { Component, Input, OnInit } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailShopCardRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-shop-card',
    templateUrl: './shop-card.component.html',
    styleUrls: ['./shop-card.component.scss'],
    standalone: false
})
export class ShopCardComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<WagtailShopCardRendererInterface>
  content?: WagtailShopCardRendererInterface
  unicodeChar: string | undefined
  
  ngOnInit(): void {
    if (this.definition) {
      this.content = this.definition.value
    }
  }
}
